import { partition } from 'es-toolkit';

export function promoteToFrontOfArray<T>(
  items: T[],
  firstTierSelector: (item: T) => boolean,
  secondTierSelector?: (item: T) => boolean,
): T[] {
  // eslint-disable-next-line prefer-const
  let [matchingItems, otherItems] = partition(items, firstTierSelector);

  if (secondTierSelector) {
    const [matchingTierTwoItems, otherTierTwoItems] = partition(otherItems, secondTierSelector);
    otherItems = matchingTierTwoItems.concat(otherTierTwoItems);
  }

  return matchingItems.concat(otherItems);
}
